import { render } from "./Regions.vue?vue&type=template&id=0fabbccd&scoped=true"
import script from "./Regions.vue?vue&type=script&lang=js"
export * from "./Regions.vue?vue&type=script&lang=js"

import "./Regions.vue?vue&type=style&index=0&id=0fabbccd&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fabbccd"]])

export default __exports__